import { connect } from 'react-redux';

import NotFoundPage from 'components/pages/NotFoundPage';

const mapStateToProps = () => ({

});

const mapDispatchToProps = () => ({

});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotFoundPage);
